module.exports = __webpack_public_path__ + "media/images/zyvo-b6806a7c8a96e10dade54a13b7178e6d.png";